import { memo } from 'react';

import { Box, TextButton } from '@zillow/constellation-10';

import { LoadingText } from '@zg-rentals/loading-components';
import { useRentalManagerUserPropertyWebAnalyticsWebApiHandler_get } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import {
  emitWhenListingExpireLearnMoreClickEvent,
  WHEN_LISTING_EXPIRE_LEARN_MORE_EVENT_ID,
} from '../../../../analytics/events/overviewPage';
import { useAuth } from '../../../AuthProvider';

const HELP_CENTER_ARTICLE =
  'https://zillow.zendesk.com/hc/en-us/articles/32837812512531-Managing-Your-Listings#h_01JKGQ7G1DQ969C3KFAPHYNQDW';

type Props = {
  listingAlias: string;
  isLoading?: boolean;
};

const WhenListingExpireLearnMore = ({ listingAlias, isLoading = false }: Props) => {
  const { user } = useAuth();

  const { data: webAnalyticsDataWithLease } = useRentalManagerUserPropertyWebAnalyticsWebApiHandler_get(
    { listingAlias, includeLeases: true },
    { enabled: Boolean(listingAlias) },
  );

  const handleLearnMoreClick = () => {
    if (webAnalyticsDataWithLease && user) {
      const { lease, ...webAnalyticsData } = webAnalyticsDataWithLease;
      emitWhenListingExpireLearnMoreClickEvent({ user, currentProperty: webAnalyticsData, lease });
    }
  };

  return (
    <Box css={{ marginTop: '200' }}>
      <LoadingText textStyle="body-sm-bold" isLoading={isLoading} loadingWidth="80%">
        When will my listing expire?{' '}
        <TextButton
          textStyle="body-sm-bold"
          asChild
          onClick={handleLearnMoreClick}
          data-eventid={WHEN_LISTING_EXPIRE_LEARN_MORE_EVENT_ID}
        >
          <a target="_blank" href={HELP_CENTER_ARTICLE} rel="noreferrer noopener">
            Learn more
          </a>
        </TextButton>
      </LoadingText>
    </Box>
  );
};

export default memo(WhenListingExpireLearnMore);
